<template>
  <el-dialog
    v-el-drag-dialog
    :modal="false"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SOPOperatingState')"
    :width="isExpand?'500px':'0px'"
    top="20vh"
    :close-on-click-modal="false"
    :class="'sop-state-dialog el-dialog__wrapper__pure' + (hideWindow ? ' hide-window' : '') + (isExpand ? '' : ' sop-state-dialog-pack-up')"
    @close="handleClose"
  >
    <template slot="title">
      <span class="el-dialog__title">{{ $t('SeaExport.SOPOperatingState') }}</span>
      <button type="button" class="el-dialog__headerbtn" style="right: 35px;" @click="isExpand=false">
        <i class="el-dialog__close el-icon el-icon-minus" />
      </button>
    </template>
    <el-scrollbar style="height: calc(80vh - 70px);" class="sop-state-scrollbar">
      <el-row class="el-row-item el-row-item-header">
        <el-col :span="7" :offset="6">{{ $t('CargoMsg.Cargo_ItemsNBR') }}</el-col>
        <el-col :span="7">{{ $t('CargoMsg.Cargo_Weight') }}KGS</el-col>
        <el-col :span="4">
          {{ $t('SeaExport.Cubage') }}M
          <sup>3</sup>
        </el-col>
      </el-row>
      <el-row class="el-row-item">
        <el-col :span="6" class="sop-state-label">{{ $t('CargoMsg.Cargo_Consignation') }}</el-col>
        <el-col :span="7">{{ job.quantityContract || 0 }}</el-col>
        <el-col :span="7">{{ job.weightContract || 0 }}</el-col>
        <el-col :span="4">{{ job.cubageContract || 0 }}</el-col>
      </el-row>
      <el-row class="el-row-item">
        <el-col :span="6" class="sop-state-label">{{ $t('SeaExport.Actual') }}</el-col>
        <el-col :span="7">{{ job.quantityActual || 0 }}</el-col>
        <el-col :span="7">{{ job.weightActual || 0 }}</el-col>
        <el-col :span="4">{{ job.cubageActual || 0 }}</el-col>
      </el-row>
      <el-row class="el-row-item">
        <el-col :span="6" class="sop-state-label">{{ $t('CargoMsg.Cargo_ChargedWeight') }}</el-col>
        <el-col :span="7">{{ job.chargeWeight || 0 }} &nbsp;M/T</el-col>
      </el-row>
      <el-row class="el-row-item">
        <el-col :span="6" class="sop-state-label">{{ $t('CargoMsg.Cargo_Size') }}</el-col>
        <el-col :span="7">{{ job.measurements }}</el-col>
      </el-row>
      <el-row v-show="showContainerInfo" class="el-row-item">
        <el-col :span="6" class="sop-state-label">{{ $t('SeaExport.ContainerInfo2') }}</el-col>
        <el-col :span="18">{{ containerInfo }}</el-col>
      </el-row>
      <el-row class="el-row-item" style="margin-left: 0;border-bottom: 1px solid #dcdfe6;" />
      <el-row class="el-row-item" style="color: #333333;">
        <el-col :span="24" style="display: flex;flex-direction: row-reverse;padding-right: 30px;">
          <span style="margin-left: 5px;color: red;">{{ $t('Message.Exception') }}</span>
          <div class="icon-solid-circle-exception" style="width: 12px;height: 12px;" />
          <span style="margin: 0 10px 0 5px;color: #1F75D5;">{{ $t('SeaExport.Completed') }}</span>
          <div class="icon-solid-circle-complete" style="width: 12px;height: 12px;" />
          <span style="margin: 0 10px 0 5px;color: orange;">{{ $t('Message.HaveInHand') }}</span>
          <div class="icon-solid-circle-progress" style="width: 12px;height: 12px;" />
          <span style="margin: 0 10px 0 5px;color: #BBBBBB;">{{ $t('Message.NotStart') }}</span>
          <div class="icon-solid-circle-origin" style="width: 12px;height: 12px;" />
        </el-col>
      </el-row>
      <el-row class="el-row-item" style="color: #333333;">
        <el-col :span="7" :offset="6">{{ $t('CargoMsg.Cargo_Time') }}</el-col>
        <el-col :span="7">{{ $t('CargoMsg.Cargo_Status') }}</el-col>
        <el-col :span="4">{{ $t('Message.Operator') }}</el-col>
      </el-row>
      <el-container>
        <el-aside width="25px" style="margin-left: 10px;margin-bottom: 12px;">
          <el-steps direction="vertical">
            <el-step v-for="(item,index) in sopStates" :key="index" :icon="'icon-solid-circle-'+item.icon" />
          </el-steps>
        </el-aside>
        <el-main style="padding: 0;">
          <el-row v-for="item in sopStates" :key="item.label" :class="'el-row-item item-'+item.icon">
            <el-col :span="6" class="sop-state-label">{{ item.label }}</el-col>
            <el-col :span="7" style="min-height: 1px">{{ item.date }}</el-col>
            <el-col :span="7" style="min-height: 1px">{{ item.state }}</el-col>
            <el-col :span="4" style="min-height: 1px">{{ item.operator }}</el-col>
            <el-col v-if="item.remark" :span="17" :offset="7">{{ item.remark }}</el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-scrollbar>
    <div v-show="isExpand" class="pack-up" @click="isExpand=false">
      <div class="el-icon-arrow-right" />
    </div>
    <div v-show="!isExpand" ref="expandDiv" class="expand" @mousedown="onMousedown">
      <div class="el-icon-circle-close" no="1" @click="handleRightClose" />
      <div style="font-size: 13px;padding: 1px 5px;cursor: pointer;" no="2" @click="handleExpand">SOP</div>
    </div>
  </el-dialog>
</template>

<script>

import { getSopStates } from '@/api/trackingService'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
export default {
  name: 'SopStateDialog',
  components: {},
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    hideWindow: { type: Boolean, default: false }, // 是否隐藏弹窗
    isNeedRefresh: { type: Boolean, required: true, default: false }, // 是否需要重新加载数据
    job: { type: Object, required: true }, // 弹框打开时默认传递条件
    defaultIsExpand: { type: Boolean, default: true }, // 默认是否展开
    isNeedExpand: { type: Boolean, default: false } // 是否需要展开
  },
  data() {
    return {
      innerVisible: this.visible,
      isExpand: true, // 是否展开
      sopStates: [], // sop状态集合
      loadDataFlag: false, // 加载数据标识
      dragFlag: false, // 拖动标识
      containerInfo: '' // 箱型箱量信息
    }
  },
  computed: {
    showContainerInfo() {
      if ((this.job.lob === SystemConstants.SE.code ||
        this.job.lob === SystemConstants.SI.code ||
        this.job.lob === SystemConstants.RE.code ||
        this.job.lob === SystemConstants.RI.code ||
        (this.job.lob === SystemConstants.IE.code && this.job.containerLoadType === ContainerLoadType.STUFFY_TT.code))) {
        // 综合物流取值为containerUsages
        if (this.job.lob === SystemConstants.IE.code && (!this.job.containerUsages || this.job.containerUsages.length <= 0)) {
          return false
        }
        // 其他取值为seaEQ
        if (!this.job.seaEQ || this.job.seaEQ.length <= 0) {
          return false
        }
        // 如果是拼箱的小票不能显示箱货信息
        if (!this.job.masterFlag && this.job.lclMasterUuid) {
          return false
        }
        // CARGO-47746 海运SOP看板。显示内容增加箱量描述
        this.convertContainerInfo()
        return true
      }
      return false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.isExpand = this.defaultIsExpand
          this.reloadData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    isNeedRefresh(newVal) {
      if (newVal) {
        this.reloadData()
      }
    },
    'job.uuid': {
      immediate: true,
      handler: function(val) {
        if (this.visible) {
          this.reloadData()
        }
      },
      deep: true
    },
    isNeedExpand(newVal) {
      if (newVal) {
        this.isExpand = true
        this.$emit('update:isNeedExpand', false)
      }
    }
  },
  mounted() {
    /* 重置SOP操作状态弹窗初始样式（margin-top、top） */
    const sopStateInner = this.$el.getElementsByClassName('el-dialog')[0]
    sopStateInner.style.marginTop = 'unset'
    sopStateInner.style.top = 'unset'
  },
  methods: {
    reloadData() {
      this.sopStates = []
      if (this.job && this.job.uuid && this.job.trackingTemplateUuid && !this.loadDataFlag) { // 加载数据
        this.loadDataFlag = true
        getSopStates({ jobUuid: this.job.uuid, trackingTemplateKey: this.job.trackingTemplateUuid }).then(res => {
          for (const item of res.data) {
            switch (item.stateType) {
              case 2:
                item.icon = 'progress'
                break
              case 3:
                item.icon = 'complete'
                break
              case 4:
                item.icon = 'exception'
                break
              default:
                item.icon = 'origin'
                break
            }
          }
          this.sopStates = res.data
        }).finally(() => {
          this.loadDataFlag = false
          this.$emit('update:isNeedRefresh', false)
        })
      }
    },
    handleClose() {
      this.$message.warning(this.$t('Message.OpenSOPPanelNeedDoubleClick'))
      this.$emit('handleClose')
    },
    onMousedown(e) {
      const expandDiv = this.$refs.expandDiv
      const disX = e.pageX - expandDiv.offsetLeft
      const disY = e.pageY - expandDiv.offsetTop
      document.onmousemove = globalEvent => {
        expandDiv.style.left = globalEvent.pageX - disX + 'px'
        expandDiv.style.top = globalEvent.pageY - disY + 'px'
        this.dragFlag = true
      }
      document.onmouseup = () => {
        document.onmousemove = document.onmouseup = null
        setTimeout(() => {
          this.dragFlag = false
        }, 100)
      }
    },
    handleRightClose() {
      if (!this.dragFlag) {
        this.innerVisible = false
      }
    },
    handleExpand() {
      if (!this.dragFlag) {
        this.isExpand = true
      }
    },
    // CARGO-47746 海运SOP看板。显示内容增加箱量描述 ‘调整一致，逗号分开，这个是测试和报告人都建议’
    convertContainerInfo() {
      this.containerInfo = ''
      // 综合物流需要使用containerUsages 其他使用seaEQ
      if (this.job.lob === SystemConstants.IE.code) {
        if (this.job.containerUsages && this.job.containerUsages.length > 0) {
          // 用于存储汇总结果的对象
          const summary = {}

          // 遍历数组，汇总数据
          this.job.containerUsages.forEach(item => {
            const eqSize = item.eqSize
            const eqType = item.eqType
            const key = `${eqSize}${eqType}` // 生成唯一的键

            // 如果该键已经存在，数量加1；否则初始化为1
            if (summary[key]) {
              summary[key] += 1
            } else {
              summary[key] = 1
            }
          })

          // 用逗号分隔生成最终的字符串结果
          this.containerInfo = Object.entries(summary).map(([key, quantity]) => {
            return `${quantity}*${key}`
          }).join(', ')
        }
      } else {
        if (this.job.seaEQ && this.job.seaEQ.length > 0) {
          // 使用 map 方法将每个元素转换为指定格式
          const formattedStrings = this.job.seaEQ.map(container => {
            return `${container.eqQuantity}*${container.eqSize}${container.eqType}`
          })

          // 使用 join 方法将所有字符串以逗号分隔拼接
          this.containerInfo = formattedStrings.join(', ')
        }
      }
    }
  }
}
</script>

<style lang="scss">
 .sop-state-dialog {
    &.hide-window {
      display: none;
    }
    &.sop-state-dialog-pack-up {
      .el-dialog__header {
        display: none;
      }
    }
    .sop-state-scrollbar {
      .el-scrollbar__wrap {
        overflow: auto;
      }
      .el-row-item {
        color: #1F75D5;
        margin-left: 35px;
        margin-bottom: 12px;
        &.el-row-item-header {
          margin-bottom: 19px;
          margin-top: 3px;
          color: #333333;
        }
        &.item-origin {
          color: #BBBBBB;
          margin-left: 0;
        }
        &.item-progress {
          color: orange;
          margin-left: 0;
        }
        &.item-complete {
          color: #1F75D5;
          margin-left: 0;
        }
        &.item-exception {
          color: red;
          margin-left: 0;
        }
        .sop-state-label {
          color: #666666;
        }
      }
    }
    &.el-dialog__wrapper__pure{
      width: 0!important;
    }
    .el-dialog {
      position: fixed;
      top: unset;
      bottom: 0;
      left: auto;
      height: 80vh;
      right: 0;
      margin-bottom: 0;
      .el-dialog__body {
        padding: 5px 0;
      }
      .el-step.is-vertical {
        .el-step__line {
          left: 5px;
        }
        .el-step__icon.is-icon {
          width: 12px;
          height: 12px;
        }
      }
      .icon-solid-circle-origin {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #BBBBBB;
      }
      .icon-solid-circle-progress {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: orange;
      }
      .icon-solid-circle-complete {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #1F75D5;
      }
      .icon-solid-circle-exception {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: red;
      }
    }
    .pack-up {
      position: absolute;
      top: calc(40vh - 30px);
      width: 20px;
      height: 60px;
      margin-left: -20px;
      background: #FFFFFF;
      border-radius: 2px;
      -webkit-box-shadow: 0 1px 3px #E3E3E3;
      box-shadow: 0 1px 3px #E3E3E3;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      .el-icon-arrow-right {
        margin: 20px 0 0 2px;
        font-size: 16px;
        color: black;
        cursor: pointer;
      }
    }
    .expand {
      position: fixed;
      top: 50%;
      right: 30px;
      width: 20px;
      height: 66px;
      background: #1F75D5;
      color: #FFFFFF;
      border-radius: 2px;
      font-size: 16px;
      opacity: 0.5;
      .el-icon-circle-close {
        padding: 3px 4px;
        cursor: pointer;
      }
    }
  }
</style>

